import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Divider,
  Card,
  CardHeader,
  CardContent,
} from "@material-ui/core";
import { LclDataContext } from "../../Contexts/LclDataContext";
import { ParcelDataContext } from "../../Contexts/ParcelDataContext";
import { HourlyDataContext } from "../../Contexts/HourlyDataContext";
import CreateHourly from "./CreateHourly";
import { makeStyles } from "@material-ui/core/styles";
import HourlyItem from "./HourlyItem";
import { roles, statuses, pageSize } from "../../Mappings";
import { UserDataContext } from "../../Contexts/UserDataContext";
import { AppStateContext } from "../../Contexts/AppStateContext";
import ButtonLoadMore from "../ButtonLoadMore";

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const useStyles = makeStyles((theme) => ({
  gapRight: {
    marginRight: theme.spacing(2),
  },
}));

const HourlyDisplayDay = (props) => {
  const { truckId, week, day, hourlySummary, setHourlySummaryPerEventDate } = props;
  const { lclData } = useContext(LclDataContext);
  const { parcelData } = useContext(ParcelDataContext);
  const { hourlyData } = useContext(HourlyDataContext);
  const { userData } = useContext(UserDataContext);
  const classes = useStyles();
  const { scrollToPosition } = useContext(AppStateContext);

  let hourlyToday = {};
  let lclToday = {};
  let parcelToday = {};

  let currentDayRemaining = 0;
  const isShowLoadMoreButton = hourlySummary?.isShowLoadMoreButton;
  
  if(hourlySummary) {
    const { currentListTotal, totalRecords } = hourlySummary;

    if(currentListTotal && totalRecords)
      currentDayRemaining = parseInt(totalRecords) - parseInt(currentListTotal)
  }

  const loadMore = () => {
    setHourlySummaryPerEventDate((state) => {
      
      const hourlySummaryPerEventDate = state.map(item => ({
        ...item,
        isSelectedToLoadMore: false
      }));

      const currentIndex = hourlySummaryPerEventDate.findIndex( f => f.weekDay == day);
      const { currentPage, currentListTotal, totalRecords} = hourlySummaryPerEventDate[currentIndex];
      hourlySummaryPerEventDate[currentIndex].currentPage =  currentPage + 1;
      hourlySummaryPerEventDate[currentIndex].isShowLoadMoreButton = totalRecords > (currentListTotal + pageSize);
      hourlySummaryPerEventDate[currentIndex].currentListTotal =  currentListTotal + pageSize;
      hourlySummaryPerEventDate[currentIndex].isSelectedToLoadMore = true;
      return hourlySummaryPerEventDate;
    })
  }  

  try {
    if (hourlyData[truckId][week][day]) {
      hourlyToday = hourlyData[truckId][week][day];
    }
  } catch {}
  try {
    lclToday = lclData[truckId][week][day];
  } catch {}
  try {
    parcelToday = parcelData[truckId][week][day];
  } catch {}
  const conNoteList = [
    ...Object.keys(lclToday)
      .filter((id) => lclToday[id].approvalState !== statuses.deleted)
      .map((id) => lclToday[id].conNoteNum),
    ...Object.keys(parcelToday)
      .filter((id) => parcelToday[id].approvalState !== statuses.deleted)
      .map((id) => parcelToday[id].cNote),
  ];

  // return to uses last position before a refresh was done
  useEffect(() => {
    scrollToPosition();
  }, [hourlyData, scrollToPosition]);

  return (
    <Card>
      <CardHeader
        title={
          <>
            {!(userData.roleId === roles.tollManager) && (
              <CreateHourly
                truckId={truckId}
                week={week}
                day={day}
                // conNoteList={conNoteList}
                className={classes.gapRight}
              />
            )}
            {days[day]}
          </>
        }
      />

      <Divider />
      <CardContent>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="stretch"
          spacing={4}
        >
          {Object.keys(hourlyToday).map((itemId) => {
            return (
              <React.Fragment key={itemId}>
                <Grid item>
                  <HourlyItem
                    itemData={hourlyToday[itemId]}
                    {...props}
                    itemId={itemId}
                    conNoteList={conNoteList}
                  />
                </Grid>
                <Divider />
              </React.Fragment>
            );
          })}
          {isShowLoadMoreButton ? 
            <ButtonLoadMore remaining={currentDayRemaining} onClickLoadMore={loadMore} />
            : null
          } 
        </Grid>        
      </CardContent>      
    </Card>
  );
};

export default HourlyDisplayDay;

HourlyDisplayDay.propTypes = {
  truckId: PropTypes.number.isRequired,
  week: PropTypes.number.isRequired,
  day: PropTypes.number.isRequired,
};
